import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '../../Box/index.js';
import 'react';
import '../../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../../hooks/useTheme.js';

var Divider = function (_a) {
    var _b = _a.stroke, stroke = _b === void 0 ? 1 : _b, _c = _a.width, width = _c === void 0 ? "full" : _c, _d = _a.color, color = _d === void 0 ? "black.20" : _d, props = __rest(_a, ["stroke", "width", "color"]);
    var applyTheme = useTheme().applyTheme;
    var borderColor = applyTheme({ color: color }).color;
    return (jsx(Box, __assign({ sx: {
            borderTop: "".concat(stroke, "px solid ").concat(borderColor),
            width: width,
        } }, props)));
};
Divider.displayName = "Divider";

export { Divider };
//# sourceMappingURL=Divider.js.map
